// vue
import { reactive } from 'vue';

// bars
import barsList from './bars';

interface IBar {
  open: number;
  close: number;
  high: number;
  low: number;
  width: number;
}

export default function () {
    const bars = reactive<IBar[]>([]);
    const barWidth = 7;

    // Диапазон старых значений
    const oldMin = 8.413079906904578;
    const oldMax = 10.57115011636928;

    // Новый диапазон
    const newMin = 0;
    const newMax = 613;

    barsList.forEach(el => {
        bars.push({
            open: ((el.open - oldMin) * (newMax - newMin)) / (oldMax - oldMin) + newMin,
            high: ((el.high - oldMin) * (newMax - newMin)) / (oldMax - oldMin) + newMin,
            low: ((el.low - oldMin) * (newMax - newMin)) / (oldMax - oldMin) + newMin,
            close: ((el.close - oldMin) * (newMax - newMin)) / (oldMax - oldMin) + newMin,
            width: barWidth,
        });
    });

    return {
        bars,
    };
}